export class Buffer {
    get bufferUsage() {
        return this._bufferUsage;
    }
    constructor(targetType, bufferUsageType) {
        this._byteLength = 0;
        this._bufferType = targetType;
        this._bufferUsage = bufferUsageType;
    }
    destroy() {
    }
}
